import PropTypes from "prop-types"

const TransactionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  sponsorId: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
  brokerUserId: PropTypes.string,
  investmentId: PropTypes.string,
  correlationId: PropTypes.string,
  senderSourceId: PropTypes.string,
  recepientSourceId: PropTypes.string,
  investorAccountId: PropTypes.string,
  retryTransactionId: PropTypes.string,
  // ...
})

export default TransactionShape
